module.exports = __webpack_public_path__ + "static/img/risk_nor1.3e32c2b8.png";